import { useNumericParams } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'

import { ModuleState } from '@redux/modules/module'

import TeamEditRoutes from './routes'

const TeamEdit = () => {
  const { teamId } = useNumericParams()

  useReduxAction(
    'teams',
    'loadTeam',
    {
      entityId: teamId,
      include_team_image_library_id: true,
      include_team_image_library: true,
      include_team_lead_agent_member: true,
      include_team_member_count: true,
      include_team_member_user: true,
    },
    [teamId],
    {
      dispatchAction: (action, requestOptions) => action(teamId, requestOptions),
      shouldPerformFn: ({ loading }: ModuleState) => !!teamId && !loading,
    },
  )

  return (
    <TeamEditRoutes />
  )
}

export default TeamEdit
